import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';

const URL_MAPS = 'https://maps.google.com/?saddr=';
const URL_GEO = 'geo:0,0?q=';

const LigneAdresse = ({ Ligne }) =>
    Ligne && (
        <React.Fragment>
            {Ligne}
            <br />
        </React.Fragment>
    );

const AdresseMultiLignes = ({
    Nom, Ad1, Ad2, Cp, Ville,
}) => (
    <React.Fragment>
        <div className="p-0 picto my-flex-item">
            <i className="fas fa-map-marker-alt" aria-hidden="true" />
        </div>
        <div className="p-0 align-self-center my-flex-item">
            { Nom ? <LigneAdresse Ligne={Nom} /> : null }
            <LigneAdresse Ligne={Ad1} />
            <LigneAdresse Ligne={Ad2} />
            <LigneAdresse Ligne={`${Cp} ${Ville}`} />
        </div>
    </React.Fragment>
);

const AdresseUneLigne = ({
    Ad1, Ad2, Cp, Ville,
}) => (
    <React.Fragment>
        {Ad1 && `${Ad1} -`} {Ad2 && `${Ad2} -`} {Cp} {Ville}
    </React.Fragment>
);

const Adresse = (props) => {
    const {
        Nom, Ad1, Ad2, Cp, Ville, RefRech, uneLigne, className,
    } = props;
    if (!Nom && !Ad1 && !Ad2 && !Cp && !Ville) return null;
    const composant = uneLigne ? <AdresseUneLigne {...props} /> : <AdresseMultiLignes {...props} />;

    return (
        <div data-toggle="tooltip" data-placement="left" title="Adresse">
            <BrowserView>
                <a
                    className={`d-flex flex-row my-flex-container ${className}`}
                    target="_blank"
                    href={`${URL_MAPS}${RefRech}`}
                >
                    {composant}
                </a>
            </BrowserView>
            <MobileView>
                <a className={`d-flex flex-row my-flex-container ${className}`} href={`${URL_GEO}${RefRech}`}>
                    {composant}
                </a>
            </MobileView>
        </div>
    );
};

export default Adresse;



// WEBPACK FOOTER //
// ./src/components/Adresse.js